import { render } from "./NavigationFooter.vue?vue&type=template&id=78034522&scoped=true"
import script from "./NavigationFooter.vue?vue&type=script&lang=js"
export * from "./NavigationFooter.vue?vue&type=script&lang=js"

import "./NavigationFooter.vue?vue&type=style&index=0&id=78034522&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78034522"]])

export default __exports__